__turbopack_context__.v({
  "backdrop": "CiudadModalSelector-module__uWOK6W__backdrop",
  "cityButton": "CiudadModalSelector-module__uWOK6W__cityButton",
  "cityButtonSelected": "CiudadModalSelector-module__uWOK6W__cityButtonSelected",
  "cityGrid": "CiudadModalSelector-module__uWOK6W__cityGrid",
  "cityListScroll": "CiudadModalSelector-module__uWOK6W__cityListScroll",
  "clearSearchBtn": "CiudadModalSelector-module__uWOK6W__clearSearchBtn",
  "fadeIn": "CiudadModalSelector-module__uWOK6W__fadeIn",
  "iconBadge": "CiudadModalSelector-module__uWOK6W__iconBadge",
  "modalCard": "CiudadModalSelector-module__uWOK6W__modalCard",
  "searchContainer": "CiudadModalSelector-module__uWOK6W__searchContainer",
  "searchIconWrapper": "CiudadModalSelector-module__uWOK6W__searchIconWrapper",
  "searchInput": "CiudadModalSelector-module__uWOK6W__searchInput",
  "zoomIn": "CiudadModalSelector-module__uWOK6W__zoomIn",
});
